import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export function ConfirmError() {
  return (
    <div className="flex flex-col mt-10 gap-10">
      <h1 className="flex items-center text-4xl md:text-5xl">{t`Link not valid`}</h1>
      <p className="text-base">
        <Trans>This verification link has already been used or is no longer active.</Trans>
        <br />
        <Trans>Please return to your original email to request a new verification if needed.</Trans>
      </p>
      <p>
        <Trans>Having trouble? Contact your system administrator.</Trans>
      </p>
    </div>
  );
}
